// Entry point for the esbuild build script (see package.json).
import * as bootstrap from "bootstrap"
import "@hotwired/turbo-rails"
import "./controllers"

// Make Bootstrap available for the occasional inline use.
window.bootstrap = bootstrap

// (Re)initialise Bootstrap tooltips and handle hash scrolling on every
// (Turbo) page load.
function initTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    if (!bootstrap.Tooltip.getInstance(el)) {
      new bootstrap.Tooltip(el)
    }
  })
}

function scrollToHash() {
  if (!window.location.hash) return
  const target = document.querySelector(window.location.hash)
  if (!target) return
  window.setTimeout(() => {
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 60, behavior: "smooth" })
  }, 300)
}

document.addEventListener("turbo:load", () => {
  initTooltips()
  scrollToHash()
})
